<template>
  <div class="baiduQueue">
      <div class="box">
          <div class="b1"><div class="b11">职位详情</div></div>
          <div class="b2">
              <div>
                  <img src="/static/index/index9.png" alt="">
                  <div>{{item.orga.province}}{{item.orga.city}}{{item.orga.area}}</div>
              </div>
              <div>
                  <img src="/static/index/index10.png" alt="">
                  <div>咨询电话：{{item.orga.callPhone}}</div>
              </div>
          </div>
          <div class="b3">
              <div class="b31">{{item.title}}</div>
              <div class="b32">{{item.salary}}</div>
          </div>
          <div class="b4">
              <div class="b41">{{item.orga.city}}  |  {{item.experience}}  |  {{item.education}}</div>
              <div class="b42">{{item.premium}}</div>
          </div>
          <div class="title">职位介绍</div>
          <div class="remark">{{item.description}}</div>
          <div class="title">{{item.orga.orgName}}</div>
          <div class="remark">{{item.orga.introduce}}</div>
      </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item:{}
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
        this.$axios.post('/get_job_detail', this.$qs.stringify({jid:this.$route.query.id})).then(res => {
            this.item=res.data.data
        })
    },
  },

  mounted() {
    this.getData();  
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  // height: 100%;
  // overflow-y: auto;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  padding-bottom: 92px;
  .box{
      width: 1132px;
      padding: 0 34px;
      margin: 0 auto;
    .b1{
        display: flex;
        align-items: center;
        justify-content: center;
        .b11{
            height: 64px;
        display:inline-block;
        padding: 0 53px;
        line-height: 64px;
        background: #333333;
        font-size: 40px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
        margin: 0 auto 18px;
        }
    }
    .b2{
        display: flex;
        align-items: center;
        justify-content: center;
        &>div{
            display: flex;
            align-items: center;
            margin-right: 69px;
            img{
                width: 18px;
                height: 18px;
                margin-right: 3px;
            }
            div{
                font-size: 24px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #999999;
            }
        }
    }
    .b3{
        display: flex;
        align-items: center;
        margin-top: 39px;
        .b31{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
        }
        .b32{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FF5602;
            margin-left: 33px;
        }
    }
    .b4{
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 60px;
    .b41{
        font-size: 18px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
margin-right: 48px;
    }
    .b42{
        font-size: 18px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
background: #1989fa11;
border-radius: 2px;
padding: 0 8px;
    }
}
    .title{
        font-size: 24px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #333333;
margin-bottom: 20px;
    }
    .remark{
        font-size: 20px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #333333;
margin-bottom: 50px;
    }
    .img{
        margin-bottom: 50px;
        img{
            width: 100%;
            margin-bottom: 20px;
        }
    }
  }
}
</style>  


// WEBPACK FOOTER //
// src/pages/recruitmentDetail/index.vue